import { useState, Fragment, useEffect } from 'react';
import IconX from '../Icon/IconX';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import DashboardTableMain from './DashboardTableMain';
import Select from 'react-select';

function DashboardDataModalWrapper({ isOpen, onClose, dashboardTableData }) {
  const [selectedDataset, setSelectedDataset] = useState(Object.keys(dashboardTableData)[0]);

  const handleDropdownChange = (selectedOption) => {
    setSelectedDataset(selectedOption.value);
  };

  const options = Object.keys(dashboardTableData).map((key) => ({
    value: key,
    label: key,
  }));

  if (!isOpen) return null;

  return (
    <div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" open={isOpen} onClose={onClose}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0" />
          </TransitionChild>
          <div className="fixed inset-0 z-[999] overflow-auto bg-[black]/60">
            <div className="flex min-h-screen items-start justify-center px-4">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel className="panel my-5 w-full max-w-7xl overflow-hidden rounded-lg border-0 p-0 text-black dark:text-white-dark">
                  <div className="flex items-end justify-end bg-[#fbfbfb] px-5 py-3 dark:bg-[#121c2c]">
                    <button onClick={onClose} type="button" className="text-white-dark hover:text-dark">
                      <IconX />
                    </button>
                  </div>
                  <div className="flex items-center justify-between bg-gray-100 px-5 py-3">
                    <label htmlFor="datasetDropdown" className="font-semibold text-secondary text-xl">
                      Select Data
                    </label>

                    <Select
                      id="datasetDropdown"
                      className="dark:bg-[#121c2c] dark:text-white w-52"
                      value={options.find((option) => option.value === selectedDataset)} // Ensure the selected value matches the format
                      onChange={handleDropdownChange} // `handleDropdownChange` receives the selected option object
                      options={options}
                    />
                  </div>

                  <div className="p-5">
                    <h3 className="font-bold text-lg mb-3">{selectedDataset}</h3>
                    <DashboardTableMain DashboardTableData={dashboardTableData[selectedDataset]} />
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}

export default DashboardDataModalWrapper;
